import { render, staticRenderFns } from "./TableInspectMerge.vue?vue&type=template&id=064a2179&scoped=true"
import script from "./TableInspectMerge.vue?vue&type=script&lang=js"
export * from "./TableInspectMerge.vue?vue&type=script&lang=js"
import style0 from "./TableInspectMerge.vue?vue&type=style&index=0&id=064a2179&prod&scoped=true&lang=scss"
import style1 from "./TableInspectMerge.vue?vue&type=style&index=1&id=064a2179&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064a2179",
  null
  
)

export default component.exports